<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <rect x="0" y="0" width="8" height="24" fill="#002395" />
    <rect x="8" y="0" width="8" height="24" fill="#FFFFFF" />
    <rect x="16" y="0" width="8" height="24" fill="#ED2939" />
</svg>
